import ListView from "./ListView/ListView";

const ProductionTargets = () => <p>ProductionTargets</p>;

ProductionTargets.ListView = ListView;
export default ProductionTargets;
